import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { registrationDisplaysTime, isRegistrationOpenForMembership, buildRegistrationPopupData } from '../column_helpers'
import RegistrationStatus from 'Shared/constants/registrationStatus'
import GolfHubPageStatus from 'Shared/constants/golfHubPageStatus'
import { GlgTooltipIcon, GlgLabel, GlgTableCell } from '../../shared/components'
import Toggle from 'react-bootstrap-toggle'
import PopupTypes from '../popup_types'

const getRegistrationLabelType = (registrationMessage) => {
  if (registrationMessage.includes('Open')) {
    return 'success'
  } else if (registrationMessage === 'Not yet open') {
    return 'info'
  } else if (registrationMessage === 'Invitation List') {
    return 'warning'
  } else if (registrationMessage === 'Membership Programs') {
    return 'primary'
  } else {
    return 'default'
  }
}

const buildRegistrationTitle = (openRegistrationData, registrationMessage, timeZoneDisplay) => {
  if (openRegistrationData.openRegistrationStatus === RegistrationStatus.INVITATION_LIST && openRegistrationData.canInvitationsList) {
    return 'Open for Invitation List'
  }
  if (registrationDisplaysTime(registrationMessage)) {
    return `${ registrationMessage } Date and time are displayed in ${ timeZoneDisplay } time`
  }
  if (isRegistrationOpenForMembership(registrationMessage)) {
    return _.join(openRegistrationData.membershipProgramsInfo.map(mp => mp.name), ', ')
  }
  return ''
}

const ACTIVE_STATUSES = new Set([ RegistrationStatus.OPEN, RegistrationStatus.INVITATION_LIST, RegistrationStatus.MEMBERSHIP ])

const RegistrationCardComponent = ({
  id, openRegistrationData, links,
  registrationMessage, timeZoneDisplay, timeZone, openPopup,
  hasPremiumRegistration, golfHubEnabled, golfHubRegistration,
  golfhubStatus, golfHubRegistrationOpen, toggleGolfhubRegistration, userIsManager,
}) => {
  const registrationTitle = buildRegistrationTitle(openRegistrationData, registrationMessage, timeZoneDisplay)

  const isRegistrationActive = ACTIVE_STATUSES.has(openRegistrationData.openRegistrationStatus)
  const isGolfhubCreated = [ GolfHubPageStatus.CREATED, GolfHubPageStatus.PUBLISHED ].includes(golfhubStatus)

  return (
    <>
      {
        userIsManager ?
          ( hasPremiumRegistration && !golfHubRegistration ?
            (
              <GlgTableCell>
                {openRegistrationData.hasOpenRegistration ? (
                  <span className='registration_cell_container'>
                    <span className={ openRegistrationData.disabledRegistrationButton ? 'registration_toggle_disabled' : '' }>
                      <Toggle
                        onClick={ () => {
                          if (!openRegistrationData.disabledRegistrationButton) {
                            openPopup(PopupTypes.INVITATION_LIST_REGISTRATION, buildRegistrationPopupData(id, openRegistrationData, timeZone))
                          }
                        }}
                        on={!window.I18n ? '' : window.I18n.t('views.golfhub.customer_center_events_actions.open_registration')}
                        off={!window.I18n ? '' : window.I18n.t('views.golfhub.customer_center_events_actions.closed_registration')}
                        className='rounded create_reg_toggle'
                        active={ isRegistrationActive }
                      />
                    </span>
                    {openRegistrationData.disabledRegistrationButton && <GlgTooltipIcon tooltip={ (!window.I18n ? '' : window.I18n.t('views.golfhub.customer_center_events_actions.disabled_registration_tooltip')) } />}
                    { registrationTitle !== '' && (
                      <GlgTooltipIcon tooltip={ registrationTitle } />
                    )}
                  </span>
                ) : (
                  <a className='create_registration_link' href={links.registrationSetupURL}>
                    {!window.I18n ? '' : window.I18n.t('views.golfhub.customer_center_events_actions.create_registration')}
                  </a>
                )}
              </GlgTableCell>
            ) : (
              golfHubEnabled && !openRegistrationData.hasOpenRegistration && (
                <GlgTableCell>
                  {golfHubRegistration && isGolfhubCreated ? (
                      <div className="golfhub_registration_cell_container">
                        <Toggle
                          onClick={ () => toggleGolfhubRegistration(id, golfHubRegistrationOpen, links.toggleRegistration) }
                          on={!window.I18n ? '' : window.I18n.t('views.golfhub.customer_center_events_actions.open_registration')}
                          off={!window.I18n ? '' : window.I18n.t('views.golfhub.customer_center_events_actions.closed_registration')}
                          className='rounded create_reg_toggle'
                          active={ golfHubRegistrationOpen }
                        />
                      </div>
                    ) : (
                      <span className='setup-golfhub-registration'>
                        <a className='create_registration_link' href={ isGolfhubCreated ? links.golfhubRegistrationSetupURL : `${links.setupGolfhubData}?show_registration_modal=true` }>
                          {!window.I18n ? '' : window.I18n.t('views.golfhub.customer_center_events_actions.create_registration')}
                        </a>
                      </span>
                  )}
                </GlgTableCell>
              )
            )
          ) : (
            <GlgTableCell>
              {registrationMessage && (
                <Fragment>
                  <GlgLabel type={ getRegistrationLabelType(registrationMessage) }>
                    { registrationMessage }
                    { registrationTitle !== '' && (
                      <GlgTooltipIcon tooltip={ registrationTitle } />
                    )}
                  </GlgLabel>
                </Fragment>
              )}
            </GlgTableCell>
          )
      }
    </>
  )
}

export default RegistrationCardComponent

RegistrationCardComponent.propTypes = {
  id: PropTypes.string.isRequired,
  openRegistrationData: PropTypes.object.isRequired,
  registrationMessage: PropTypes.string,
  timeZoneDisplay: PropTypes.string,
  timeZone: PropTypes.string,
  openPopup: PropTypes.func.isRequired,
  hasPremiumRegistration: PropTypes.bool,
  golfHubEnabled: PropTypes.bool,
  golfHubRegistration: PropTypes.bool,
  golfhubStatus: PropTypes.string,
  golfHubRegistrationOpen: PropTypes.bool,
  toggleGolfhubRegistration: PropTypes.func,
  links: PropTypes.shape({
    togglePublished: PropTypes.string,
    setupGolfhubData: PropTypes.string,
    golfhubDirectoryPage: PropTypes.string,
    registrationSetupURL: PropTypes.string,
    golfhubRegistrationSetupURL: PropTypes.string,
    toggleRegistration: PropTypes.string,
  }),
  userIsManager: PropTypes.bool,
}
